import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';

function ChartDonut({ data, keyProp }) {
  const [series, setSeries] = useState([]);
  const [labels, setLabels] = useState([]);
  const [colors, setColors] = useState([]);

  useEffect(() => {
    if (data && data.length) {
      const labelChart = data.map((item) => `${item.title}`);
      const valueChart = data.map((item) => item.value);
      const colorsChart = data.map((item) => item.color);
      setSeries(valueChart);
      setLabels(labelChart);
      setColors(colorsChart);
    }
  }, [data, keyProp]);

  const options = {
    chart: {
      type: 'donut',
    },
    legend: {
      show: true,
      position: 'bottom',
    },
    responsive: [
      {
        breakpoint: 50,
        options: {
          chart: {},
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
    labels: labels,
    colors: colors,
  };

  return (
    <div>
      <div>
        <ReactApexChart
          options={options}
          series={series}
          type="donut"
          height={235}
          key={keyProp} 
        />
      </div>
    </div>
  );
}

export default ChartDonut;
